import type {RouteLocationNormalizedLoaded} from 'vue-router'
import {EventBus, LOAD_RESENT_VIEWS} from '@/utils/event-bus'
import {appInstance} from '@/utils/app-accessor'

export async function useRecentViewsData(route: RouteLocationNormalizedLoaded, linkName: string, companyType?: string) {
    const userId = authStore.person.personId
    const routePath = route.path
    const dateNow = Date.now()
    const modifiedDate = new Date(dateNow).toISOString()
    const routeName = route.name

    try {
        await appInstance.$api.recentViews.post({userId, routePath, linkName, routeName, companyType, modifiedDate})
        EventBus.$emit(LOAD_RESENT_VIEWS)
        // eslint-disable-next-line no-empty
    } catch (e) {}
}
